export const ModalActionTypes = {
  OPEN_CLOSE: "open_close",
};
